import { useState } from 'react';
import Button from 'epn-ui/umd/dist/components/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/pro-regular-svg-icons/faLink';
import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen';
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash';
import { faDownload } from '@fortawesome/pro-regular-svg-icons/faDownload';
import { toast } from 'react-toastify';
import useI18n from '@i18n';
import copyTextToClipboard from '@utils/clipboard';

import BaseToast from '@base/BaseToast';

export interface IActionsProps {
    id: number;
    downloadLink: string;
    updateLink: string;
    onDeleteOfferById: (id: number) => void;
}

const Actions: React.FC<IActionsProps> = ({ id, downloadLink, updateLink, onDeleteOfferById }) => {
    const { t } = useI18n();
    const [isDeleting, setIsDeleting] = useState(false);

    const onCopyLink = async (link: string) => {
        try {
            await copyTextToClipboard(link);

            toast.success(<BaseToast text={t('Link copied')} type="success" />, {
                toastId: link,
            });
        } catch {
            toast.success(<BaseToast text={t('Something went wrong')} type="error" />, {
                toastId: link,
            });
        }
    };

    const onDelete = async (feedId: number) => {
        setIsDeleting(true);

        try {
            await onDeleteOfferById(feedId);
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <div className="flex flex-wrap items-start xs:items-center xs:max-w-none max-w-28">
            <Button
                size="small"
                className="w-10 h-8 mt-2 mr-2 xs:mt-0 min-w-10"
                to={downloadLink}
                type="ghost"
                title={t('Download')}
            >
                <FontAwesomeIcon icon={faDownload} />
            </Button>
            <Button
                size="small"
                className="w-10 h-8 mt-2 xs:mr-2 xs:mt-0 min-w-10"
                type="ghost"
                title={t('Copy link')}
                onClick={() => onCopyLink(downloadLink)}
            >
                <FontAwesomeIcon icon={faLink} />
            </Button>
            <Button
                size="small"
                className="w-10 h-8 mt-2 mr-2 xs:mt-0 min-w-10"
                type="ghost"
                to={updateLink}
                title={t('Edit')}
            >
                <FontAwesomeIcon icon={faPen} />
            </Button>
            <Button
                size="small"
                className="w-10 h-8 mt-2 xs:mt-0 min-w-10"
                type="ghost"
                onClick={() => onDelete(id)}
                title={t('Delete')}
                loading={isDeleting}
            >
                {!isDeleting && <FontAwesomeIcon icon={faTrash} />}
            </Button>
        </div>
    );
};

export default Actions;
